exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".GitHubMarkdown.updates td:first-child{width:140px}", "", {"version":3,"sources":["/Users/yuki/Public/wp-admin/src/components/routes/Home.vue"],"names":[],"mappings":"AACA,uCACE,WAAa,CACd","file":"Home.vue","sourcesContent":["\n.GitHubMarkdown.updates td:first-child {\n  width: 140px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5ce1c20e","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/routes/Home.vue
// module id = 830
// module chunks = 5